import { render } from "./AboutCollegeView.vue?vue&type=template&id=53a3cc5a"
import script from "./AboutCollegeView.vue?vue&type=script&lang=js"
export * from "./AboutCollegeView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__